import { render, staticRenderFns } from "./StatisticsTrendsSale.vue?vue&type=template&id=c84a07f8&scoped=true"
import script from "./StatisticsTrendsSale.vue?vue&type=script&lang=ts"
export * from "./StatisticsTrendsSale.vue?vue&type=script&lang=ts"
import style0 from "./StatisticsTrendsSale.vue?vue&type=style&index=0&id=c84a07f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84a07f8",
  null
  
)

export default component.exports